/* eslint-disable comma-dangle */
import api from '@/api';
import {
  CONFLICT,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = `${process.env.VUE_APP_BASE_API}/category`;
const HANDLED_ERRORS = [NOT_ACCEPTABLE, CONFLICT, UNPROCESSABLE_ENTITY, UNAUTHORIZED, NOT_FOUND];

const baseResponse = (response) => {
  let errors = null;
  const { status } = response;

  if (HANDLED_ERRORS.includes(status)) {
    errors = {
      status,
      statusText: response.statusText || response.data.message,
    };
  }

  const { data } = response;

  return {
    data,
    errors,
  };
}

export default {
  getAll: async () => {
    const response = await api.get(baseAPI);
    return baseResponse(response);
  },

  create: async (category) => {
    const response = await api.post(baseAPI, category);
    return baseResponse(response);
  },

  update: async (category) => {
    const response = await api.put(`${baseAPI}/${category.categoryId}`, category);
    return baseResponse(response);
  },

  delete: async (category) => {
    const response = await api.delete(`${baseAPI}/${category.categoryId}`);
    return baseResponse(response);
  }
};
